/**
 * Created by daniesy on 09/11/2016.
 */
var d3 = require('d3');

export default class Conclusion {
    constructor(text) {
        this.text = text;
    }

    drawInElement(element) {
        this.conclusionElement = element
            .append('div')
            .attr('class', 'conclusion');

        this.conclusionElement.text(this.text);

        this.conclusionElement.html(this.text).append('img').attr('src', 'assets/info.svg');
    }
}



// WEBPACK FOOTER //
// ./src/js/conclusion.js